// import {
//     urlEncode
// } from '../utils';
import {
    mapState
} from 'vuex';

const Mixins = {
    install(Vue) {
        Vue.mixin({
            // data() {
            //     return {
            //         count
            //     }
            // },
            computed: {
                ...mapState({
                    host: state => state.host,
                    token: state => state.token,
                    cdn: state => state.cdn,
                    win: state => state.win,
                    userInfo: state => state.userInfo,
                    wxUserInfo: state => state.wxUserInfo,
                    companyInfo: state => state.companyInfo
                })
            },
            methods: {
                PUSH(data) {
                    try {
                        window.storeSaveInstance(window.getCurrentPath(), this.$data);
                    } catch (e) {
                        console.log('storeSaveInstance', e);
                    }
                    if (data.type == 'r') {
                        this.REPLACE(data);
                    } else {
                        this.$router.push(data);
                    }
                },
                REPLACE(data) {
                    let path = window.getCurrentPath();
                    // 跟 router.push 很像，唯一的不同就是，它不会向 history 添加新记录，而是跟它的方法名一样 —— 替换掉当前的 history 记录。
                    if (this.$store.state.terminal == 'wxApp') {
                        try {
                            wx.miniProgram.redirectTo({
                                url: data
                            });
                        } catch (error) {

                        }
                    } else {
                        this.$router.replace(data);
                    }
                    window.deleteSaveInstance(path);
                },
                GO(data) {
                    console.log('GO this.$store.state.terminal', this.$store.state.terminal);
                    if (this.$store.state.terminal == 'wxApp') {
                        try {
                            wx.miniProgram.navigateBack({
                                delta: 1
                            });
                        } catch (error) {

                        }
                    } else {
                        this.$router.go(data);
                    }
                },
                // push(data) {
                //     if (!data.path) {
                //         data.path = data.name;
                //     }
                //     let query = urlEncode(data.query).replace(/&/, '?');
                //     let url = `/pages/${data.path}/main${query}`;
                //     let type = data.type || 'n';
                //     console.log('data.query', data.query, query);
                //     console.log('url', url, type);
                //     if (type == 'n' || type == 'navigateTo') {
                //         //保留当前页面，跳转到应用内的某个页面
                //         wx.navigateTo({
                //             url
                //         });
                //     }
                //     if (type == 'r' || type == 'redirectTo') {
                //         // 关闭当前页面，跳转到应用内的某个页面。
                //         wx.redirectTo({
                //             url
                //         });
                //     }
                //     if (type == 's' || type == 'switchTab') {
                //         // 跳转到tabBar页面（在app.json中注册过的tabBar页面），同时关闭其他非tabBar页面。
                //         wx.switchTab({
                //             url
                //         });
                //     }
                //     if (type == 'l' || type == 'reLanch') {
                //         // 关闭所有页面，打开到应用内的某个页面。
                //         wx.reLanch({
                //             url
                //         });
                //     }
                // },
                // back(num = 1) {
                //     // 关闭当前页面，返回上一页面或多级页面。可通过 getCurrentPages() 获取当前的页面栈，决定需要返回几层。
                //     // 跳转到页面 A
                //     // console.log('getCurrentPages', wx.getCurrentPages());
                //     wx.navigateBack({
                //         delta: num
                //     });
                // },
                /**
                 * 格式化金钱
                 * @param {*} num 金额/元
                 * @param {*} precision 精度
                 * @param {*} separator 间隔符
                 * https://segmentfault.com/q/1010000000119327
                 */
                formatMoneyYen(num, precision, separator) {
                    var parts;
                    // 判断是否为数字
                    if (!isNaN(parseFloat(num)) && isFinite(num)) {
                        // 把类似 .5, 5. 之类的数据转化成0.5, 5, 为数据精度处理做准, 至于为什么
                        // 不在判断中直接写 if (!isNaN(num = parseFloat(num)) && isFinite(num))
                        // 是因为parseFloat有一个奇怪的精度问题, 比如 parseFloat(12312312.1234567119)
                        // 的值变成了 12312312.123456713
                        num = Number(num);
                        // 处理小数点位数
                        num = (typeof precision !== 'undefined' ? num.toFixed(precision) : num).toString();
                        // 分离数字的小数部分和整数部分
                        parts = num.split('.');
                        // 整数部分加[separator]分隔, 借用一个著名的正则表达式
                        parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','));

                        return parts.join('.');
                    }
                    return NaN;
                },
                queryUserInfo() {
                    let param = {};
                    this.$http.post('shopInfo/getLoginInfo.do', param).then((res) => {
                        let data = res.data;
                        this.$store.commit('updateSignIn', data);
                        try {
                            // this.$store.commit('updateOpenId', data.profileVo.wxEcOpenId);
                            this.$store.commit('updateOpenId', data.profileVo.wxEcOpenId);
                        } catch (error) {
                        }
                        console.log('res', data);
                    }).catch((err) => {
                        console.log('err', err);
                    });
                },
                getFileLink(id, link) {
                    if (!link) {
                        return `${window.location.origin}/bdsaasfile/ajax/common/getFileNotAuth.do?fileId=${id}&token=${this.$store.state.token}&COMPANYID=${this.$store.state.companyId}`;
                    }
                    return link;
                }
            }
        });
    }
};

export default Mixins;
